const defaultAccess = ['Chief', 'Admin', 'Tanks', 'TankAdmin', 'TankChief'];
const viewers = ['Viewer', 'TankViewer'];

export const tanksAccionesRoles = {
  sharedActions: {
    scanPackingBox: [...defaultAccess, 'TankOperator', 'TankLeader'],
    viewPackingInfo: [
      ...defaultAccess,
      ...viewers,
      'TankOperator',
      'TankLeader',
    ],
    palletReports: [...defaultAccess],
    palletRegistration: [...defaultAccess, 'TankOperator', 'TankLeader'],
    validatePallets: [...defaultAccess, 'TankLeader'],
    scanPartScrap: [...defaultAccess, 'TankOperator', 'TankLeader'],
    packingBox: [...defaultAccess, 'TankLeader'],
  },
  sideNavActions: {
    root: [
      'Chief',
      'Admin',
      'Tanks',
      'TanksAdmin',
      'TanksChief',
      'TanksViewer',
      'Viewer',
    ],
    reportsPbiTanks: [
      'Chief',
      'Admin',
      'Tanks',
      'TanksAdmin',
      'TanksChief',
      'TanksViewer',
      'Viewer',
    ],
  },
  routerActions: {
    viewData: [...defaultAccess],
  },
};
